module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_1",
      "title": "1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#p_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PART ONE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "PTT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#p_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE ASPIRING CHANTEUSE")])]), _vm._v(" "), _c('p', {
    staticClass: "PEP"
  }, [_vm._v("An opera begins long before the curtain goes up and ends long after it has come down. It starts in my imagination, it becomes my life, and it stays part of my life long after I’ve left the opera house.")]), _vm._v(" "), _c('p', {
    staticClass: "PEPC"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("—Maria Callas")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726f9926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 72
// module chunks = 0